import SortableImage from './SortableImage'

export default SortableImage
